const defaultCurriculumDisplayName = "Amira Default";
const defaultCurriculumConfig = { 
  "EN-US": { displayName: defaultCurriculumDisplayName, curriculumId: "default", locale: "EN_US" },
  "ES-MX": { displayName: defaultCurriculumDisplayName, curriculumId: "esmx_default", locale: "ES_MX" },
};

export default defaultCurriculumConfig;
export { defaultCurriculumDisplayName };